var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"white--text align-end",attrs:{"src":"https://cdn.vuetifyjs.com/images/cards/house.jpg","gradient":"to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)","height":"200px"},on:{"click":function($event){return _vm.changeImage()}}})}
var staticRenderFns = []

export { render, staticRenderFns }